import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export type Autenticacao2faPendingAction = { type: 'reveal' } | { type: 'navigate'; to: RouteLocationRaw };

export interface Autenticacao2faOpenOptions {
  api: string;
  onSuccess?: Autenticacao2faPendingAction;
}

const useAutenticacao2faModalStore = defineStore('autenticacao2faModal', () => {
  const isOpen = ref(false);
  const api = ref<string | null>(null);
  const pendingAction = ref<Autenticacao2faPendingAction | null>(null);

  function open(opts: Autenticacao2faOpenOptions) {
    api.value = opts.api;
    pendingAction.value = opts.onSuccess ?? { type: 'reveal' };
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  function clearPending() {
    pendingAction.value = null;
    api.value = null;
  }

  return {
    isOpen,
    api,
    pendingAction,
    open,
    close,
    clearPending,
  };
});

export default useAutenticacao2faModalStore;
